import {
    BlockScrollStrategy,
    ScrollDispatcher,
    ScrollStrategyOptions,
    ViewportRuler,
} from '@angular/cdk/overlay';
import { DOCUMENT } from '@angular/common';
import {
    Inject,
    Injectable,
    NgZone,
} from '@angular/core';

export class UiBlockScrollStrategy extends BlockScrollStrategy {

    constructor(
        viewportRuler: ViewportRuler,
        @Inject(DOCUMENT)
        public document: Document,
    ) {
        super(viewportRuler, document);
    }

    /** Unblocks page-level scroll while the attached overlay is open. */
    disable() {
        super.disable();

        const html = this.document.documentElement;
        const body = this.document.body;

        if (body.style.scrollBehavior === '') {
            delete body.style.scrollBehavior;
        }
        if (html.style.scrollBehavior === '') {
            delete html.style.scrollBehavior;
        }
    }
}

@Injectable({ providedIn: 'root' })
export class UiScrollStrategyOptions extends ScrollStrategyOptions {
    constructor(
        scrollDispatcher: ScrollDispatcher,
        ngZone: NgZone,
        // tslint:disable-next-line: naming-convention
        private __viewportRuler: ViewportRuler,
        // tslint:disable-next-line: naming-convention
        @Inject(DOCUMENT) private __document: any) {
        super(scrollDispatcher, __viewportRuler, ngZone, __document);
    }


    block = () => new UiBlockScrollStrategy(this.__viewportRuler, this.__document);
}
